import React from 'react'
import './stepLineHistory.css'

const StepLineHistory = (props) => {
  const type = props.type
  const isStartPoint = props.isStartPoint ? props.isStartPoint : false
  const bgColor = isStartPoint || type ? 'rgba(0, 24, 94, 1)' : 'grey'

  return (
    <div className='valcde_step_lineHistory'>
      {!isStartPoint || type ? <div style={{ width: '91px', height: '3px', backgroundColor: bgColor }}></div> : <div />}

      <div
        style={{
          width: '9px',
          height: '9px',
          borderRadius: '50%',
          backgroundColor: bgColor,
        }}
      ></div>
    </div>
  )
}

export default StepLineHistory
